import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LightBox from './LightBox';

const LightBoxContainer = () => {
  const { t } = useTranslation();
  const [src, setSrc] = useState(undefined);
  const handleOpen = useCallback((e) => {
    setSrc(e.detail.src);
  }, []);
  const handleClose = useCallback(() => {
    setSrc(undefined);
  }, []);
  useEffect(() => {
    window.addEventListener('lightbox', handleOpen);
    return () => {
      window.removeEventListener('lightbox', handleOpen);
    };
  }, [handleOpen]);
  return <LightBox handleClose={handleClose} src={src} t={t} />;
};

export default LightBoxContainer;
